export var UPDATE_CHART_SETTINGS = '@chart-settings/UPDATE_CHART_SETTINGS';
export var RESET_CHART_SETTINGS = '@chart-settings/RESET_CHART_SETTINGS';